import { GenericFailure, CommonSuccess } from '@playq/services-shared';

import { UseMutationOptionsExtended, useEitherMutation } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { logOutFromAllSessionsKey } from './constants';

export const useLogOutFromAllSessions = (options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error>) =>
  useEitherMutation(() => services2.userSessionsService.logOutEveryWhere(), {
    mutationKey: logOutFromAllSessionsKey,
    ...options,
    meta: {
      onErrorMessage: (err: GenericFailure) => ({
        message: `Error occured while trying to log out from all sessions: ${err.message}`,
        log: true,
      }),
      ...options?.meta,
    },
  });
